// Cross browser KeyboardEvent.key values
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key

export const KeyMap: Record<string, (string | number)[]> = {
  DOWN: ['Down', 'ArrowDown', 40],
  END: ['End', 35],
  ESCAPE: ['Esc', 'Escape', 27],
  ENTER: ['Enter', 13],
  HOME: ['Home', 36],
  LEFT: ['Left', 'ArrowLeft', 37],
  PAGE_DOWN: ['PageDown', 34],
  PAGE_UP: ['PageUp', 33],
  RIGHT: ['Right', 'ArrowRight', 39],
  SHIFT: ['Shift', 16],
  SPACE: [' ', 32],
  UP: ['Up', 'ArrowUp', 38],
};

export const KeyConstants = {
  DOWN: 'DOWN',
  END: 'END',
  ESCAPE: 'ESCAPE',
  ENTER: 'ENTER',
  HOME: 'HOME',
  LEFT: 'LEFT',
  PAGE_DOWN: 'PAGE_DOWN',
  PAGE_UP: 'PAGE_UP',
  RIGHT: 'RIGHT',
  SHIFT: 'SHIFT',
  SPACE: 'SPACE',
  UP: 'UP',
};

const EmailRegex = /^.+@.+$/;

export default {
  KeyMap,
  KeyConstants,
  EmailRegex,
};
